module.exports = __webpack_public_path__ + "static/media/adaptive-icon.89d99845.png";